import TooltipWrapper from "@app/shared/TooltipWrapper";

interface WaffleRowTooltipProps {
  elements: string[];
  containerClassName?: string
}

const WaffleRowTooltip: React.FC<WaffleRowTooltipProps> = ({ elements, containerClassName }) => {

  const displayedElements = elements.length > 2 ? 
                            `${elements.slice(0, 2).join(', ')}, ...` :
                            elements.join(', ');

  const showTooltip = elements.length > 2;                    

  return (
    <>
      {showTooltip ? (
        <TooltipWrapper 
          containerClassName={containerClassName}
          position="auto"
          text={
            <ul className="list-unstyled mb-0">
              {elements.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
           </ul>
          }
         >
          <p>{displayedElements}</p>
        </TooltipWrapper>    
      ) :
      (
        <div>{displayedElements}</div>
      )}
    </>
  );
};

export default WaffleRowTooltip;